import "./EngineeredWoodAndCementCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Casestudyhero from "./sections/Casestudyhero";
import Industrycasestudy from "./sections/Industrycasestudy";
import Footer from "@/reusable_sections/Footer";
export default function EngineeredWoodAndCementCaseStudyPage() {
  return <div>
      <Header />
      <Casestudyhero />
      <Industrycasestudy />
      <Footer />
    </div>;
}